import {RestApiService} from '../../../rest-api.service';
import {RelationCreateReq, RelationDetailRes, RelationTypeRes} from '../../../../contracts/v0/crm/relation.contract';
import {ApiV0Crm} from '../api.v0.crm';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmRelation {
    segment = '/relation';

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }
    search(searchModel:SearchModel = new SearchModel({})):Observable<BaseCollectionModel<RelationDetailRes>>{
        return this.rest.post<SearchModel,BaseCollectionModel<RelationDetailRes>>(`${this.segment}/search`, RelationDetailRes, searchModel)
    }
    createRelation(createReq: RelationCreateReq) {
        return this.rest.post<RelationCreateReq, RelationDetailRes>(`${this.segment}/create`, RelationDetailRes, createReq)
    }

    createRelationType() {

    }

    getRelationTypes() {
        return this.rest.get<BaseCollectionModel<RelationTypeRes>>(`${this.segment}/type`, BaseCollectionModel<RelationTypeRes>)
    }
}
